import {
  GraduationCap,
  CheckSquare,
  UsersRound,
  UserRoundPlus,
  School,
  LayoutGrid,
  UserRoundX,
  ClipboardCheck,
} from "lucide-react";

/**
 * Student & Classes hub — split out from the original combined
 * "Students & Staff" hub.
 *
 * Covers:
 * - Students
 * - Classes
 * - Sections
 * - Student attendance
 *
 * The `icon` property contains the Lucide icon component.
 * Visual styling/decorations are handled centrally by HubIcon.
 *
 * Existing permission and owner/staff portal behavior is preserved.
 */
export const hubStudentClassesLinks = [
  {
    sectionTitle: "Student Management",
    sectionIcon: GraduationCap,

    links: [
      {
        label: "Student List",
        url: "/students",
        desc: "All enrolled students",
        module: "STUDENT_MANAGEMENT",
        permission: "STUDENT_MANAGEMENT_VIEW",
        icon: UsersRound,
      },

      {
        label: "Add Student",
        url: "/students/create",
        desc: "Enroll a new student",
        module: "STUDENT_MANAGEMENT",
        permission: "STUDENT_MANAGEMENT_FULL",
        icon: UserRoundPlus,
      },

      /**
       * No /staff-panel/classes route currently exists.
       * Therefore this remains owner-only.
       *
       * HubGrid / HubSection already handle permission === null
       * correctly for portal users.
       */
      {
        label: "Classes",
        url: "/classes",
        desc: "Class list & structure",
        module: "STUDENT_MANAGEMENT",
        permission: null,
        icon: School,
      },

      /**
       * No /staff-panel/sections route currently exists.
       * Therefore this remains owner-only.
       */
      {
        label: "Sections",
        url: "/sections",
        desc: "Sections within each class",
        module: "STUDENT_MANAGEMENT",
        permission: null,
        icon: LayoutGrid,
      },
    ],
  },

  {
    sectionTitle: "Student Attendance",
    sectionIcon: CheckSquare,

    links: [
      {
        label: "Absent Today",
        url: "/attendance/absent-today",
        desc: "Students absent today, across sections",
        module: "STUDENT_ATTENDANCE",
        permission: "STUDENT_ATTENDANCE_VIEW",
        icon: UserRoundX,
      },

      {
        label: "Section Attendance",
        url: "/attendance/section",
        desc: "Mark or review attendance by section",
        module: "STUDENT_ATTENDANCE",
        permission: "STUDENT_ATTENDANCE_VIEW",
        icon: ClipboardCheck,
      },
    ],
  },
];

export default hubStudentClassesLinks;